<template>
  <BaseModal
    no-header
    no-footer
    v-model="modal"
    :title="$t('profile_page.personal_info.exit')"
  >
    <!--    <img-->
    <!--      @click="modal = false"-->
    <!--      class="absolute right-6 top-6 cursor-pointer"-->
    <!--      src="@/assets/svg/close.svg"-->
    <!--      alt="exit"-->
    <!--    />-->
    <div>
      <div
        class="bg-red flex-center mx-auto h-[104px] w-[104px] border-white/20 rounded-full border-2 shadow-exit"
      >
        <img
          src="@/assets/svg/exit-modal-icon.svg"
          alt="exit"
          class="object-cover"
        />
      </div>
      <p class="text-center text-xl mt-5 text-dark font-medium">
        {{ $t("profile_page.personal_info.exit_profile.title") }}
      </p>
      <p class="text-center mt-1 text-sm">
        {{ $t("profile_page.personal_info.exit_profile.description") }}
      </p>
      <div class="w-full flex gap-3 mt-6">
        <BaseButton
          variant="neutral"
          class="flex-1"
          :text="$t('back')"
          @click="modal = false"
        />
        <BaseButton
          class="bg-red text-white hover:bg-red/90 flex-1"
          :text="$t('profile_page.personal_info.exit_profile.exit')"
          @click="exit()"
        />
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { BaseModal, BaseButton } from "@/components/Base";
import { useAuthStore } from "@/modules/Authorization/store";

const modal = defineModel<boolean>();

const authStore = useAuthStore();

/**
 * Clearing the session is the part that actually logs you out; the navigation is just what the
 * student sees. This used to navigate and reload WITHOUT clearing anything, which left a valid
 * token in storage — so the router bounced the "logged out" user straight back into their profile,
 * and the token stayed usable by anyone else on the device.
 *
 * A full document navigation rather than a router push: it drops every Pinia store along with the
 * session, so the next person to sign in on this device cannot see the previous student's cached
 * profile, contracts or payments. `replace` keeps the authenticated page out of history, so Back
 * cannot return to it.
 */
const exit = () => {
  modal.value = false;
  authStore.logout();
  window.location.replace("/sign-in");
};
</script>
<style scoped>
.shadow-exit {
  box-shadow: 0px 8px 44px 0px rgba(194, 15, 32, 0.32);
}
</style>
